import { all, fork } from 'redux-saga/effects';

import sagas from './redux/sagas';

export default function* rootSaga() {
  yield all([...sagas].map((s) => fork(s)));
}
